export default ({ app }, inject) => {
  inject('removeHtmlTags', (text) => {
    if (!text) return null
    return text?.replace(/<[^>]*>/g, '')
  })
}
